export default __webpack_public_path__ + "static/media/banner_right_pic.d77631b6.png";